<template>
  <div :class="['avatar-container', isSelected ? 'setting-selected' : '']" @click="avatarClicked">
    <img class="avatar-img" :src="src" />
    <div ref="avatarName" class="avatar-name">{{ name }}</div>
    <img :class="['triangle-image', { 'triangle-flip': isSelected }]" :src="iconTriangle" />
  </div>
</template>
<script lang="ts" setup>
  import iconTriangle from '@assets/svgs/icon-triangle.svg'
  import { useSharedActiveMainHeaderItem, MainHeaderItems } from '@/core/compositions/ActiveMainHeaderItem'
  import { computed, ref, watch } from 'vue'
  import { debounce } from 'lodash-es'

  const { currentSelectedItem, updateCurrentSelectedItem, avatarNameContainerWidthGap } =
    useSharedActiveMainHeaderItem()

  const isSelected = computed(() => currentSelectedItem.value === MainHeaderItems.SETTINGS_MAIN_PAGE)

  const props = defineProps<{
    src?: string
    name?: string
  }>()

  const avatarClicked = () => {
    updateCurrentSelectedItem(MainHeaderItems.SETTINGS_MAIN_PAGE)
  }
  const avatarName = ref<HTMLDivElement>()
  const AVATAR_NAME_CONTAINER_WIDTH = 66
  const avatarNameContainerWidth = ref<string>(AVATAR_NAME_CONTAINER_WIDTH + 'px')
  const getAvatarNameContainerWidth = debounce(() => {
    avatarNameContainerWidthGap.value =
      AVATAR_NAME_CONTAINER_WIDTH - (avatarName.value?.getBoundingClientRect().width ?? AVATAR_NAME_CONTAINER_WIDTH)
  }, 1000)

  watch(props, getAvatarNameContainerWidth)
</script>
<style lang="stylus" scoped>
  .avatar-container
    box-sizing border-box
    height 36px
    cursor pointer
    flex-all-center()
    &:hover
      .avatar-img
        border solid 2px active_color
  .avatar-img
    rect(24px)
    border solid 2px transparent
    cursor pointer
    margin-right 8px
    border-radius 50%
    box-sizing content-box
  .avatar-name
    margin-right 10px
    max-width v-bind(avatarNameContainerWidth)
    ellipsis()
  .triangle-image
    transition transform 0.3s ease
  .triangle-flip
    triangle-transform()
  .setting-selected
    .avatar-img
      border solid 2px active_color !important

  @import '../styles/h5Adaptive/MainHeader.styl'
</style>
